import { thermalCategories, thermalProductsByCategory, thermalProductPath } from './thermal';

/** Solutions navigation tree shared by the footer (mirrors the header dropdown). */
export const SOLUTIONS_MENU = [
  {
    name: 'UL101 Ultrasonic Troubleshooter (B00033)',
    path: '/products/ul101',
    children: [
      { name: 'UL101 Aviation Troubleshooter Kit (B00033)', path: '/products/ul101' },
      { name: 'UL101 Replacement Parts', path: '/products/ul101#kit-parts' },
      { name: 'UT2000 Universal Transmitter (026012)', path: '/products/ul101#part-026012' },
      { name: 'UT2000 Cabin Multi-Pak — Set of 4 (026305)', path: '/products/ul101#part-026305' },
      { name: 'UT2000 Cabin Multi-Pak — Set of 8 (026310)', path: '/products/ul101#part-026310' },
    ],
  },
  {
    name: 'UL101 + Acoustic Camera Combo Kits',
    path: '/products/combo-kits',
    children: [
      { name: 'B00700 — UL101 Ultrasonic Inspection and Listening Kit (H6)', path: '/products/combo-kits/b00700' },
      { name: 'B00705 — UL101 Compact Ultrasonic Inspection and Imaging Kit (H4mini)', path: '/products/combo-kits/b00705' },
    ],
  },
  {
    name: 'Acoustic Cameras',
    path: '/products/fotric',
    children: [
      { name: 'H4mini', path: '/products/acoustic-cameras/h4mini' },
      { name: 'H-Series (H4 / H6)', path: '/products/acoustic-cameras/h-series' },
      { name: 'H-Flex', path: '/products/acoustic-cameras/h-flex' },
      { name: 'H7', path: '/products/acoustic-cameras/h7' },
    ],
  },
  ...Object.values(thermalCategories).map((c) => ({
    name: c.name,
    path: c.path,
    children: thermalProductsByCategory(c.slug).map((p) => ({ name: p.menuName, path: thermalProductPath(p) })),
  })),
  {
    name: 'Aviation Headsets and GSE Team Kits',
    path: '/products/dalcomm',
    children: [
      { name: 'Wireless Intercom Kit', path: '/products/dalcomm/wireless-intercom-kit' },
      { name: 'Embry-Riddle Aviation Headset', path: '/products/dalcomm/embry-riddle-aviation-headset' },
      { name: 'J1 Carbon Fiber Pilot’s Headset', path: '/products/dalcomm/j1-carbon-fiber-pilots-headset' },
      { name: 'Vintage Aviation Headset', path: '/products/dalcomm/vintage-aviation-headset' },
      { name: 'GSE Adapters & Accessories', path: '/products/dalcomm/gse-adapters' },
    ],
  },
];
